import { render, staticRenderFns } from "./UserViewAccountContact.vue?vue&type=template&id=48e8fa53&v-if=userData.contact&"
import script from "./UserViewAccountContact.vue?vue&type=script&lang=js&"
export * from "./UserViewAccountContact.vue?vue&type=script&lang=js&"
import style0 from "./UserViewAccountContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports